module.exports = "<div class=\"modal-footer\">\n  <div ng-transclude></div>\n</div>\n"